import { PinwheelIcon } from './PinwheelIcon';

/**
 * author: Google
 * id BB298846-B608-4289-987C-A8F2A904409F
 * name pinwheel
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pinwheel.svg
 * tags
 */
export const ToysIcon = PinwheelIcon;
export default ToysIcon